export default __webpack_public_path__ + "static/gamerPlayBg-1c69b998ea1342f353403027df422930.png";